import { SiteSurveyUnit } from "api/types/siteSurveyUnit";

export function getFormikNameForUnitProps(
  unitIndex: number,
  unitPropName: keyof SiteSurveyUnit
) {
  return `units[${unitIndex}].${unitPropName}`;
}
